// import {  useEffect, useState } from "react";
import { useEffect, useState } from 'react';

import Mainmenu from './MainMenu';
// import LoadingDots from "./LoadingDots";

import bot from '../../assets/images/happy.png'
import Frame1 from './Frame1';


const Greetings = () => {
    const [time] = useState(new Date());


    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
      };
      const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data
    setTimeout(() => setLoading(false), 1000); 
  }, []);
    return(
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1 animated-frame">
            <strong>{getGreeting()}</strong>, Greetings from Medicover Hospitals<br/>
            </div>
            <div className="frame1 animated-frame">
            <strong>Medicover Hospitals</strong> is a leading Multispecialty Hospital chain with a significant presence in India. We provide a broad spectrum of health care services and have an extensive network of clinics, hospitals, specialty care facilities, Fertility Centers, and diagnostic labs.

Medicover Hospitals is spread across the Four states of Telangana, Andhra Pradesh, Maharashtra and Karnataka treating millions of patients every year with a focus on augmenting healthcare standards in India. We have renowned medical teams who work with the greatest technologies and international evidence-based protocols which offer the most comprehensive treatment across all specialties of medicines.

            </div>
            <Frame1 />
        </>
    );
}
export default Greetings;   